enum BarrelKind {
    Default = "default",
    Onboarding = "onboarding"
}

export default BarrelKind;
